module.exports = __webpack_public_path__ + "img/OmniChatBot.6a1ed929.svg";